<template>
  <div>
    <div class="slide" v-for="bild in bildspel">
      <div class="h1">
        {{bild.name}}
      </div>
      <img :src="bild.bild">
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bildspel: null
    }
  },
  mounted () {
    this.$http.get(
      'http://api.lootbox.se/v1/feed/5a15b2f0ba79b',
      {
        emulateJSON: true,
        withCredentials: true
      }
    ).then(({body}) => {
      this.bildspel = body
    }, () => {
      console.log('Fail!')
    })
  }
}
</script>

<style lang="sass">
@import './../sass/core.sass'

.h1
  font-size: 32px

img
  width: 300px

.slide
  background: orange
  border: 10px solid black

+block('background')
  width: 100%
  height: 400px
  background-size: cover
  background-repeat: no-repeat
  background-position: center
  position: relative

+block('name')
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%,-50%)
  font-weight: bold
  color: #FFF
  text-shadow: 0 2px 2px rgba(0,0,0,.2)
  font-size: 36px
  text-align: center
  width: 100%

strong
  font-weight: bold

</style>



// WEBPACK FOOTER //
// src/routerViews/Test.vue